import { Button, Tooltip } from 'antd';
import React, { useCallback } from 'react';

const Confirmation = ({
  close = () => { },
  mergeIsDisabled = true,
  t = (s) => s,
  setAreYouSureState = () => { },
  areYouSureState = false,
  onSubmit = () => { },
  onCheck = () => { },
}) => {
  const mergeClicked = useCallback(() => {
    if (!areYouSureState) {
      onCheck()
      return;
    }
    onSubmit();
  }, [areYouSureState, onSubmit, onCheck]);

  const closeClicked = useCallback(() => {
    if (areYouSureState) {
      setAreYouSureState(false);
      return;
    }
    close();
  }, [close, areYouSureState, setAreYouSureState]);

  return (
    <div className="actions">
      <Button onClick={closeClicked}>
        {t('Cancel')}
      </Button>
      <Tooltip title={mergeIsDisabled ? t('Please fill required fields') : null}>
        <Button onClick={mergeClicked} disabled={mergeIsDisabled} type="primary">
          {t(areYouSureState ? 'Confirm' : 'Merge')}
        </Button>
      </Tooltip>
    </div>
  );
}

export default Confirmation;
